import { Injectable, signal } from '@angular/core';
import { type CalloutType } from '../callout/callout.model';
import { type Toast } from './toast.model';

@Injectable({ providedIn: 'root' })
export class ToastService {
  private counter = 0;

  readonly toasts = signal<Toast[]>([]);

  show(options: {
    message: string;
    title?: string;
    type?: CalloutType;
    dismissible?: boolean;
    duration?: number;
  }): number {
    const id = ++this.counter;
    const toast: Toast = {
      id,
      message: options.message,
      title: options.title,
      type: options.type ?? 'info',
      dismissible: options.dismissible ?? true,
      duration: options.duration ?? 4000,
    };

    this.toasts.update((list) => [...list, toast]);

    if (toast.duration > 0) {
      setTimeout(() => this.dismiss(id), toast.duration);
    }

    return id;
  }

  /**
   * Show an error toast in the top-right corner that auto-dismisses after
   * `secondsForShow` seconds.
   */
  showApplicationError(message: string, secondsForShow = 5): number {
    return this.show({ message, type: 'error', duration: secondsForShow * 1000 });
  }

  dismiss(id: number): void {
    this.toasts.update((list) => list.filter((t) => t.id !== id));
  }

  dismissAll(): void {
    this.toasts.set([]);
  }
}
